import React from 'react';
import { FaCrown, FaClock } from 'react-icons/fa';

/**
 * Card affichant le statut premium ou période d'essai de l'utilisateur dans la sidebar.
 */
function PremiumBadge({ isPremium, isTrial, className = '' }) {
  if (!isPremium && !isTrial) return null;
  const isPremiumStatus = isPremium;
  const label = isPremiumStatus ? 'Premium' : 'Essai actif';
  const sublabel = isPremiumStatus
    ? 'Accès complet à toutes les fonctionnalités'
    : 'Explorez les avantages Premium';

  return (
    <div
      className={`premium-status-card premium-status-card--${isPremiumStatus ? 'premium' : 'trial'} ${className}`}
      title={label}
    >
      <div className="premium-status-card__icon">
        {isPremiumStatus ? (
          <FaCrown aria-hidden="true" />
        ) : (
          <FaClock aria-hidden="true" />
        )}
      </div>
      <div className="premium-status-card__content">
        <span className="premium-status-card__label">{label}</span>
        <span className="premium-status-card__sublabel">{sublabel}</span>
      </div>
    </div>
  );
}

export default PremiumBadge;
